<template>
  <div>
    <div class="row">
      <div class="col-sm-12">
        <RhFssDetail :fss='fss'> </RhFssDetail>
      </div>
    </div>
  </div>
</template>

<script>
import RhFssDetail from '@/components/rh/rhFssDetail.vue'
import axios from 'axios';

export default {
  data: function() {return {
    fss: {
      adresse:{po_box: null},
      p1718:{rh:[]},
      p1819:{rh:[]},
      p1920:{rh:[]},
      p2021:{rh:[]}
    }
  }},

  name: 'RhFss',
  components: {
    RhFssDetail,
  },
  methods: {
    refresh: function() {
      axios
        .get(this.$root.$data.server_base + '/api/on/rh_details.php',
          { params: {agency_id: this.$route.params.agency_id}})
        .then(response => (this.fss = response.data))
    }
  },
  mounted () {
    this.refresh()
  }
}
</script>
